<template>
  <div class="business-trip-pdf-container">
    <!-- PDF Preview Dialog -->
    <v-dialog
      v-model="pdfDialog"
      fullscreen
      transition="dialog-bottom-transition"
      content-class="pdf-dialog"
    >
      <v-card class="pdf-card">
        <v-toolbar color="white" flat class="pdf-toolbar">
          <v-toolbar-title class="toolbar-title">
            <v-icon class="mr-2" color="#455a64">mdi-file-pdf-box</v-icon>
            ดู PDF รายงานการเดินทางราชการ
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <div class="toolbar-actions">           
            <v-btn
              icon
              small
              class="action-icon-btn ml-2"
              @click="pdfDialog = false"
              title="ปิด"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-toolbar>

        <div class="pdf-container">
          <div v-if="pdfLoading" class="pdf-loading">
            <v-progress-circular
              indeterminate
              color="#455a64"
            ></v-progress-circular>
            <p class="mt-3">กำลังสร้าง PDF...</p>
          </div>          
          <iframe v-else :src="'/HRvec_api/exports/' + pdfUrl" class="pdf-iframe"></iframe>
        </div>
           
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <v-snackbar
      v-model="snackbar.show"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      top
      right
    >
      <div class="d-flex align-center">
        <v-icon class="mr-3" color="white">{{ snackbar.icon }}</v-icon>
        <span>{{ snackbar.text }}</span>
      </div>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "BusinessTripReportPDF",

  props: {
    reportId: {
      type: [String, Number],
      required: true
    },
    ApiKey: {
      type: String,
      default: "HRvec2021"
    }
  },

  data() {
    return {
      pdfDialog: false,
      pdfUrl: "",
      pdfLoading: false,
      snackbar: {
        show: false,
        color: "",
        timeout: 3000,
        icon: "",
        text: ""
      }
    };
  },

  methods: {
    async openPDFViewer() {
      await this.generatePDF();
      this.pdfDialog = true;
    },

    async generatePDF() {
      this.pdfUrl ={}
      try {
        let data = {
          ApiKey: this.ApiKey,
          id: this.reportId
        };
        const response = await this.$http.post(
          "gov_business_trip_report_generate_pdf.php",
          data
        );       
        this.pdfUrl = response.data.pdfUrl
       
      } catch (error) {
        this.showSnackbar("เกิดข้อผิดพลาดในการสร้าง PDF", "error", "mdi-alert");
        console.error("PDF Generation Error:", error);
      } finally {
        this.pdfLoading = false;
      }
    },

    async downloadPDF() {
      try {
        const response = await this.$http.post(
          "gov_business_trip_report_generate_pdf.php",
          {
            ApiKey: this.ApiKey,
            id: this.reportId,
            action: "download"
          },
          {
            responseType: "blob"
          }
        );

        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `report_${this.reportId}_${new Date().getTime()}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

        this.showSnackbar("ดาวน์โหลดสำเร็จ", "success", "mdi-check-circle");
      } catch (error) {
        this.showSnackbar("เกิดข้อผิดพลาดในการดาวน์โหลด", "error", "mdi-alert");
        console.error("Download Error:", error);
      }
    },

    printPDF() {
      if (this.pdfUrl) {
        const printWindow = window.open(this.pdfUrl);
        if (printWindow) {
          printWindow.print();
        } else {
          this.showSnackbar(
            "ไม่สามารถเปิดหน้าต่างปริ้นได้",
            "error",
            "mdi-alert"
          );
        }
      }
    },

    showSnackbar(text, color, icon) {
      this.snackbar = {
        show: true,
        text,
        color,
        icon,
        timeout: 3000
      };
    }
  }
};
</script>

<style scoped>
.business-trip-pdf-container {
  font-family: "Prompt", sans-serif;
}

.pdf-dialog {
  background: #f5f5f5 !important;
}

.pdf-card {
  border-radius: 0 !important;
  box-shadow: none !important;
  background: white !important;
}

.pdf-toolbar {
  border-bottom: 1px solid #e5e7eb;
  padding: 12px 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.toolbar-title {
  font-size: 16px;
  font-weight: 500;
  color: #263238;
  display: flex;
  align-items: center;
}

.toolbar-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.action-icon-btn {
  color: #6b7280 !important;
  transition: all 0.2s ease;
}

.action-icon-btn:hover {
  color: #455a64 !important;
  background: #f5f5f5 !important;
}

.pdf-container {
  height: calc(100vh - 70px);
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
}

.pdf-loading {
  text-align: center;
  color: #6b7280;
}

.pdf-iframe {
  width: 100%;
  height: 100%;
  border: none;
}

::v-deep .v-dialog__container {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
